import TEmpty from './empty.vue'

TEmpty.install = Vue => {
  Vue.component(TEmpty.name, TEmpty)
}

export default TEmpty



// WEBPACK FOOTER //
// ./src/module/empty/index.js